export default "__VITE_ASSET__CBL7yIIO__"